var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"padded-space",attrs:{"id":"activity-payments-view"}},[_c('h2',[_vm._v("Client Payments")]),_c(_setup.ActivityPaymentsListBlock,{attrs:{"showExport":_setup.canExport,"documentsTitle":"Client Payments"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }